import { ClassName, Size } from '@busybusy/webapp-react-ui';
import { IDivProps } from '@busybusy/webapp-react-ui/dist/types/props/DivProps';
import classNames from 'classnames';
import { forwardRef } from 'react';
import './FullContentHeaderDialogContent.scss';

export interface IFullContentHeaderDialogContentProps extends IDivProps {
  divider?: boolean;
  headerSize?: Size;
  className?: ClassName;
}

const sizeLookup: Record<Size, number> = {
  [Size.SMALL]: 52,
  [Size.MEDIUM]: 64,
  [Size.LARGE]: 80,
  [Size.XL]: 100,
  [Size.GROW]: NaN,
};

const FullContentHeaderDialogContent = forwardRef<HTMLDivElement, IFullContentHeaderDialogContentProps>(
  ({ headerSize = Size.LARGE, divider = true, className, ...divProps }, ref) => {
    const classes = classNames('full-content-header-dialog-content', className);
    const headerSpace = sizeLookup[headerSize] + (divider ? 1 : 0);
    const contentHeight = `calc(100% - ${headerSpace}px)`;
    return <div className={classes} {...divProps} style={{ ...divProps.style, height: contentHeight }} ref={ref} />;
  }
);

FullContentHeaderDialogContent.displayName = 'FullContentHeaderDialogContent';

export default FullContentHeaderDialogContent;
